export default __webpack_public_path__ + "static/media/platforms_tablet.469d27f2.svg";